module.exports = __webpack_public_path__ + "static/the-remains-of-the-day-3462acdcf40456aa75c08a77c68db7df.jpg";